import { copy } from '../content/copy';
import { reachGoal } from '../../lib/metrika';
import { LButton } from '../components/LButton';
import { Underline } from '../components/Underline';
import { NumberAnchor } from '../components/NumberAnchor';
import { Marginalia } from '../components/Marginalia';

export function Hero() {
  const { hero } = copy;
  return (
    <section className="bg-l-paper px-6 md:px-10 pt-14 md:pt-20 pb-20 md:pb-24">
      <div className="mx-auto max-w-[1120px] grid grid-cols-1 md:grid-cols-[7fr_5fr] gap-10 md:gap-14 items-center">
        <div className="flex flex-col gap-8">
          <h1 className="font-display font-medium text-l-ink-deep text-[44px] md:text-[64px] leading-[1.05] tracking-[-0.02em]">
            {hero.h1.before}
            <em className="not-italic">
              <Underline>{hero.h1.accent}</Underline>
            </em>
          </h1>
          <p className="font-sans text-l-ink text-[17px] md:text-[19px] leading-[1.6] max-w-[520px]">
            {hero.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 sm:items-center">
            <LButton href="#contact" variant="primary" onClick={() => reachGoal('cta_click')}>
              {hero.ctaPrimary}
            </LButton>
            <LButton href="#cases" variant="ghost">
              {hero.ctaSecondary}
            </LButton>
          </div>
          <p className="font-sans text-l-ink-muted text-sm">{hero.subline}</p>
        </div>

        <div className="flex flex-col gap-5">
          <img
            src="/landing/maria.jpg"
            alt={hero.photoAlt}
            className="w-full rounded-lg shadow-ring-lg aspect-[4/5] object-cover"
            fetchPriority="high"
          />
          <Marginalia>{hero.photoCaption}</Marginalia>
        </div>
      </div>

      <div className="mx-auto max-w-[1120px] mt-16 md:mt-20 pt-10 border-t border-l-rule grid grid-cols-3 gap-6">
        {hero.stats.map((s) => (
          <NumberAnchor key={s.label} value={s.value} label={s.label} />
        ))}
      </div>
    </section>
  );
}
